import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';

import { OppvarmingFormData } from '../../../../types';
import { ServiceSisteToArRadio } from '../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../common/varmesystemBruk';
import { VarmesentralRadio } from '../../common/varmesentralRadio';
import { InstallertIOppvarmetRomRadio } from '../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const VannbarenVarme = () => {
  const { watch } = useFormContext<OppvarmingFormData>();

  const showFordelingssystem = watch('varmepumpe.value.vannbarenVarme.bruk.romoppvarming');

  return (
    <Fragment>
      <InstallasjonsArRadio
        name={`varmepumpe.value.vannbarenVarme.varmesentral`}
        translationKeyPrefix={`form.oppvarming.varmepumpe.varmesentral.installasjonsAr`}
      />
      <VarmesentralRadio name="varmepumpe.value.vannbarenVarme.varmesentral.varmesentralType" />
      <InstallertIOppvarmetRomRadio name="varmepumpe.value.vannbarenVarme.varmesentral.installertIOppvarmetRom" />

      <InstallasjonsArRadio
        name={`varmepumpe.value.vannbarenVarme`}
        translationKeyPrefix={`form.oppvarming.varmepumpe.installasjonsAr`}
      />
      <ServiceSisteToArRadio name="varmepumpe.value.vannbarenVarme.serviceGjennomfortSiste2Ar" />
      <VarmesystemBrukCheckboxes name="varmepumpe.value.vannbarenVarme.bruk" />
      {showFordelingssystem && <Fordelingssystem />}
    </Fragment>
  );
};
